'use es6';

import createSimpleCachedReferenceResolver from 'reference-resolvers/lib/createSimpleCachedReferenceResolver';
import * as CacheKeys from 'reference-resolvers/constants/CacheKeys';
import { createGetAllInboundDbLists, getAllInboundDbLists } from 'reference-resolvers/api/InboundDbListsAPI';
export const createInboundDbTicketListReferenceResolver = options => createSimpleCachedReferenceResolver(Object.assign({
  cacheKey: CacheKeys.INBOUND_DB_TICKET_LIST,
  createFetchData: opts => createGetAllInboundDbLists(opts)('TICKET'),
  fetchData: getAllInboundDbLists('TICKET')
}, options));
export default createInboundDbTicketListReferenceResolver();